import React, { useEffect } from "react";

import Popup from "../components/Popup";

import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useHttp } from "../hooks/useHttp";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import LoadingCenter from "../components/LoadingCenter";
import openToast from "../utils/sweetAlert";

const schema = yup.object({
  option: yup.string().required("É necessário selecionar uma opção acima!").nullable()
}).required();

const PopupJoinCustomersChoice = props => {
  const { trigger, setTrigger, customers } = props;

  const request = useHttp();

  const { data: customer, isLoading, isFetching, refetch } = useQuery(
    ["customer"],
    () => request({ url: `/users/${customers.selectedCustomerJoin}`, method: "GET" }), {
      refetchOnWindowFocus: false
    }
  );

  const joinMutation = useMutation(
    ["join-mutation"],
    data => request({ url: "/users/unificar", method: "POST", data: data }), {
    onSuccess: res => {
      if (!res?.data.error) {
        openToast("success", "Sucesso", res?.data.message);
        setTrigger(false);
      }

      if (res.data.error) {
        openToast("error", "Ocorreu um erro", res?.data.message);
      }
    }
  });

  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const submitJoin = data => {
    const newData = {
      "chat_user_id": data.option,
      "user_1": customers.selectedCustomer.id,
      "user_2": customers.selectedCustomerJoin
    };

    joinMutation.mutate(newData);
  };

  useEffect(() => {
    refetch();
  }, [customers.selectedCustomerJoin]);

  return (
    <Popup title="Unificar clientes" trigger={trigger} setTrigger={setTrigger} width="400">
      {(isLoading || isFetching) && <LoadingCenter />}

      {(!isLoading && !isFetching) && <div className="chat__filter ">
        <span className="text-color d-block ml-20 mr-20 mt-10 mb-10">
          De qual cliente você deseja manter o chat? (você só terá acesso ao chat do cliente escolhido)
        </span>

        <form onSubmit={handleSubmit(submitJoin)}>
          <ul className="last-access-list ml-20 mr-20 mt-10 mb-10">
            <li>
              <label className="label-last-accesses">
                <input type="radio" name="option" value={customers.selectedCustomer.id} {...register("option")} />
                <span className="text-color">
                  <strong>{customers.selectedCustomer.name}</strong>
                </span>
              </label>
            </li>
            <li>
              <label className="label-last-accesses">
                <input type="radio" name="option" value={customers.selectedCustomerJoin} {...register("option")} />
                <span className="text-color">
                  <strong>{customer?.data?.name}</strong>
                </span>
              </label>
            </li>
          </ul>

          {errors.admin && <div className="x-p-20 y-p-20 mp-0 text-error">{errors.option.message}</div>}

          <div className="popup-footer ml-20 mr-20 mt-10 mb-20">
            <button className="btn btn-primary" type="submit">
              {joinMutation.isLoading ? "Carregando, aguarde..." : "Concluir"}
            </button>
            <button className="btn btn-light mr-20" type="submit" onClick={() => setTrigger(false)}>Cancelar</button>
          </div>
        </form>
      </div>}
    </Popup>
  );
}

export default PopupJoinCustomersChoice;